import { render, staticRenderFns } from "./supplies.vue?vue&type=template&id=8d6c2dfa"
import script from "./supplies.vue?vue&type=script&lang=js"
export * from "./supplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports